import "./EmployeeDirectory.scss";
import React, {useEffect, useState} from "react";
import {Tabs} from "components/common";
import type {TabsProps} from "antd";

import {tabKeys} from "../../../../types/enums";

import ListEmployees from "./components/ListEmployee/ListEmployees";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import Detail from "./components/Detail/Detail";
import License from "./components/License/License";
import LaborContract from "./components/LaborContract/LaborContract";
import CatalogManage from "./components/Catalog/Catalog";
import {setButtonsHeader, setSiderKey} from "../../../../redux/reducer/common";
import WorkHistory from "./components/WorkHistory/WorkHistory";

const EmployeeDirectory = () => {
  document.title = "Danh sách nhân viên";
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisabledCT, setIsDisabledCT] = useState(true);
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(state => state.common.activeTab);

  useEffect(() => {
    dispatch(setSiderKey("nhanVien"));
  }, []);

  const items: TabsProps["items"] = [
    {
      key: tabKeys.EMPLOYEE.LIST_EMPLOYEE,
      label: `Danh sách nhân viên  `,
      children: (
        <ListEmployees
          setIsTabDisabled={setIsDisabled}
          setIsTabDisabledCT={setIsDisabledCT}
        />
      ),
    },
    {
      key: tabKeys.EMPLOYEE.DETAIL,
      label: `Chi tiết thông tin  `,
      children: <Detail />,
      disabled: isDisabledCT,
    },
    {
      key: tabKeys.EMPLOYEE.CONTRACT,
      label: `Hợp đồng lao động  `,
      children: <LaborContract />,
      disabled: isDisabled,
    },
    {
      key: tabKeys.EMPLOYEE.LICENSE,
      label: `Giấy phép hành nghề  `,
      children: <License />,
      disabled: isDisabled,
    },
    {
      key: tabKeys.EMPLOYEE.WORK_HISTORY,
      label: `Lịch sử công tác`,
      children: <WorkHistory />,
      disabled: isDisabled,
    },
    {
      key: tabKeys.EMPLOYEE.CATALOG,
      label: `Cấu hình danh mục  `,
      children: <CatalogManage />,
    },
  ];
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);

  return (
    <div className="employee-directory page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default EmployeeDirectory;
